import React, { useContext, useEffect, useRef, useState } from "react";
import { Modal, Button, notification, Alert } from "antd";
import { createPortal } from "react-dom";
import { defaultProps, modalsByContext } from "./modals";
import { ModalContext } from "../../../engine/context/Modal.provider";
import CustomForm from "../CustomForm";
import { useParams } from "react-router-dom";
import {
  initDateEndPrestation,
  initDateStartPrestation,
} from "../../../pages/Prestations/Slices/Prestation.default.state";
import dayjs from "../../../utils/dayjs";
import { onlyRoleMapping, userHasLevel } from "../../../engine/AuthRoute";
import {
  renderUserName,
  roles,
  typeIntervention,
} from "../../../utils/constants";
import {
  disabledDateNext12Months,
  disabledDatePast,
  validateTimeBetween,
} from "../CustomForm/form.helpers";
import { AiFillCalendar } from "react-icons/ai";
import { DurationHourChecker } from "../../../pages/Prestations/PrestationDetail/DurationHourChecker";
import { BiLinkExternal } from "react-icons/bi";
import { useTranslation } from "react-i18next";
import { http } from "../../../engine/api/http";

export const UsersDuplicator = ({ defaultOpen }) => {
  const [open, setOpen] = useState(defaultOpen);
  const formRef = useRef(null);
  const context = useContext(ModalContext);
  const { t } = useTranslation();

  useEffect(() => {
    setOpen(defaultOpen);
  }, [defaultOpen]);

  const close = () => {
    setOpen(false);
    context.closeModal(modalsByContext.UsersDuplicator);
  };

  const onSubmitForm = async data => {
    if (data.sources.includes(data.target)) {
      notification.error({
        message: t("common.error"),
        description: t("usersDuplicator.sameUserError"),
      });
      // SET Error  validation message !!!ü on formRef
      formRef.current.setFields([
        {
          name: "target",
          errors: [t("usersDuplicator.sameUserError")],
        },
      ]);
      return;
    } else {
      try {
        const caller = await http.post("/users/duplicator", data);
        notification.success({
          message: t("usersDuplicator.success"),
          description: t("usersDuplicator.successDescription"),
        });
        close();
      } catch (e) {
        console.log(e);
      }
    }
  };

  const inputs = inputsDuplicator({ t });

  const config = {
    key: modalsByContext.UsersDuplicator,
    title: t("usersDuplicator.title"),
    open: open,
    cancelText: t("common.close"),
    okText: t("usersDuplicator.confirm"),
    onOk: () => {
      // Placeholder: simulate form submit
      onSubmitForm();
    },
    onCancel: close,
    content: (
      <>
        <Alert
          message={t("usersDuplicator.alertTitle")}
          description={t("usersDuplicator.alertDescription")}
          type="warning"
          showIcon
          closable={true}
        />
        {/* TODO: Add form fields here */}
        <CustomForm
          dataSource={inputs}
          handleSubmit={data => onSubmitForm(data)}
          labelCol={24}
          refForm={formRef}
          wrapperCol={24}
          onValuesChange={undefined}
        />
      </>
    ),
    footer: [
      <Button key="close" onClick={close}>
        {t("common.close")}
      </Button>,
      <Button
        type="primary"
        onClick={() => {
          formRef.current.submit();
        }}
      >
        {t("usersDuplicator.confirmAndDuplicate")}
      </Button>,
    ],
  };

  return (
    <>
      {createPortal(
        <Modal {...config}>{config.content}</Modal>,
        document.querySelector("#modals"),
      )}
    </>
  );
};

// Helper for cross-field validation

export const inputsDuplicator = ({ t, form }) => {
  return [
    {
      parentLabel: "",
      children: [
        {
          label: t("inputsSelector.userTarget"),
          name: "target",
          required: true,
          type: "dynamic-select",
          multiple: false,
          endPoint: `users?role=${roles.institution}&status=active,inactive,archived`,
          col: 24,
          noSorting: true,
          itemCallback: item => {
            let label = `${renderUserName(item)} - ${item.email}`;
            let search = renderUserName(item) + " " + item.email;
            return {
              key: item._id,
              label: label,
              value: item._id,
              search: search,
            };
          },
        },
        {
          label: t("inputsSelector.usersSources"),
          name: "sources",
          required: true,
          type: "dynamic-select",
          multiple: true,
          endPoint: `users?role=${roles.institution}&status=active,inactive,archived`,
          col: 24,
          value: [],
          itemCallback: item => {
            let label = `${renderUserName(item)} - ${item.email}`;
            let search = renderUserName(item) + " " + item.email;
            return {
              key: item._id,
              label: label,
              value: item._id,
              search: search,
            };
          },
        },
        // {
        //   col: 24,
        //   type: "component",
        //   noWrapper: true,
        //   name: "durationHour",
        //   component: ({ refForm }) => (
        //     <DurationHourChecker
        //       keys={["intervention.startDate", "intervention.endDate"]}
        //       isLongDuration={false}
        //     />
        //   ),
        // },
      ],
    },
  ];
};
